import Icon from '../components/Icon.vue'

Icon.register({"stop-circle":{"width":512,"height":512,"paths":[{"d":"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM352 336C352 344.8 344.8 352 336 352H176C167.2 352 160 344.8 160 336V176C160 167.2 167.2 160 176 160H336C344.8 160 352 167.2 352 176V336z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/stop-circle.js
// module id = n/TV
// module chunks = 0